export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      try {
        // Versioned SW URL to bypass cache + force fresh fetch (prevents stale SW)
        const swUrl = `/sw.js?v=${Date.now()}`;
        navigator.serviceWorker
          .register(swUrl)
          .then((registration) => {
            console.log('SW registered:', registration);

            // Handle updates
            registration.addEventListener('updatefound', () => {
              const newWorker = registration.installing;
              if (newWorker) {
                console.log('[SW] update found');
                newWorker.addEventListener('statechange', () => {
                  if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    showUpdatePrompt();
                  }
                });
              }
            });

            // Check for updates periodically (swallow errors to avoid unhandled rejections)
            setInterval(() => {
              registration.update().catch((err) => console.warn('[SW] update check failed:', err));
            }, 60000); // Check every minute
          })
          .catch((error) => {
            console.warn('[SW] registration failed (graceful):', error); // warn not log to reduce noise
          });
      } catch (error) {
        console.warn('[SW] registration error:', error);
      }
    });
  }
}

function showUpdatePrompt() {
  const SW_REFRESH_SESSION_KEY = 'sw_auto_refresh_done_admin_health';

  // Only auto-reload on admin/health once per page load (prevents loops)
  if (window.location.pathname === '/admin/health' && !sessionStorage.getItem(SW_REFRESH_SESSION_KEY)) {
    console.log('[SW] Auto-refreshing on admin/health page (once per session)');
    sessionStorage.setItem(SW_REFRESH_SESSION_KEY, 'true');
    window.location.reload();
    return;
  }

  // For other pages or when on cooldown, show user-friendly prompt
  import('sonner').then(({ toast }) => {
    toast('New version available – Refresh', {
      description: 'A new update has been downloaded and is ready to use.',
      action: {
        label: 'Refresh',
        onClick: () => window.location.reload(),
      },
      duration: 10000, // Show for 10 seconds
    });
  });
}

// Check online/offline status
export function initializeOnlineStatus() {
  const updateOnlineStatus = () => {
    if (navigator.onLine) {
      document.body.classList.remove('offline');
      console.log('App is online');
    } else {
      document.body.classList.add('offline');
      console.log('App is offline');
    }
  };

  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
  updateOnlineStatus();
}
